import { render } from "./FormCreateParent.vue?vue&type=template&id=555945a8&scoped=true"
import script from "./FormCreateParent.vue?vue&type=script&lang=js"
export * from "./FormCreateParent.vue?vue&type=script&lang=js"

import "./FormCreateParent.vue?vue&type=style&index=0&id=555945a8&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-555945a8"]])

export default __exports__